// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:1447px){.expand{flex-flow:row nowrap;justify-content:flex-start}.expand .navbar-nav{flex-direction:row}.expand .navbar-nav .dropdown-menu{position:absolute}.navbar-collapse{display:flex!important;flex-basis:auto}.navbar-toggler{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
